import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.onLogoutClick();
  }

  onLogoutClick(){
    this.authService.logout();
    this.router.navigate(['login'])
  }

}



// WEBPACK FOOTER //
// ./src/app/logout/logout.component.ts